import { useQueryClient } from '@tanstack/react-query';
import { getInternalDeliveryBudgetGetYearlyBudgetsQueryKey } from 'api/internal-delivery-budget/internal-delivery-budget';
import {
  getInternalDeliveryDailyBudgetOverrideGetDailyBudgetOverridesQueryKey,
  useInternalDeliveryDailyBudgetOverrideUpdateDailyBudgetOverride,
} from 'api/internal-delivery-daily-budget-override/internal-delivery-daily-budget-override';
import { useCallback } from 'react';

export interface UpsertDailyBudgetOverrideArgs {
  companyId: number;
  date: Date;
  overrideId?: number;
  amount: number;
  transferredFromPreviousDay?: number;
  plannedAmount?: number;
}

const useUpsertDailyBudgetOverride = () => {
  const updateOverride =
    useInternalDeliveryDailyBudgetOverrideUpdateDailyBudgetOverride();
  const queryClient = useQueryClient();

  const upsert = useCallback(
    (args: UpsertDailyBudgetOverrideArgs, onSuccess?: () => void) => {
      updateOverride.mutate(
        {
          data: {
            dailyBudgetOverrideID: args.overrideId ?? -1,
            companyID: args.companyId,
            date: args.date,
            amount: args.amount,
            transferredFromPreviousDay: args.transferredFromPreviousDay,
            plannedAmount: args.plannedAmount,
          },
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries(
              getInternalDeliveryDailyBudgetOverrideGetDailyBudgetOverridesQueryKey()
            );
            queryClient.invalidateQueries(
              getInternalDeliveryBudgetGetYearlyBudgetsQueryKey()
            );
            onSuccess?.();
          },
        }
      );
    },
    [updateOverride, queryClient]
  );

  return {
    upsert,
    isLoading: updateOverride.isLoading,
  };
};

export default useUpsertDailyBudgetOverride;
